<template>
	<div class="row justify-content-center">
		<div class="col-lg-5 col-md-12">
			<div class="card shadow-sm">
				<div class="card-header">
					<div class="d-flex align-items-center justify-content-between">
						<h3 class="df-title">New Policy</h3>
					</div>
				</div>
				<div class="card-body">
					<form class="row" @submit.prevent="createPolicy">
						<div class="form-group col-12">
							<label>Company</label>
							<select v-model="form.external_client_id" id="company" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('external_client_id') }" required>
								<option :value="null" disabled>Select company</option>
							</select>
							<has-error :form="form" field="external_client_id"></has-error>
						</div>
						<div class="form-group col-12">
							<label>Policy Type</label>
							<select v-model="form.policy_type" id="policy_type" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('policy_type') }" required>
								<option :value="null" disabled>Select policy type</option>
								<option v-for="(policyType, index) in policyTypes" :value="policyType.tag" :key="index">{{ policyType.name }}</option>
							</select>
							<has-error :form="form" field="external_portfolio_id"></has-error>
						</div>
						<div v-if="!isEmpty(approvers) && form.policy_type === 'APPROVAL_POLICY'" class="form-group col-12">
							<label>Select Approvers</label>
							<select
								v-model="form.meta_data.approvers"
								id="approvers"
								class="form-control custom-select shadow-sm"
								:class="{ 'is-invalid': form.errors.has('form.meta.approvers') }"
								multiple="multiple"
							>
								<option v-for="(user, index) in approvers" :value="user.user_id" :key="index">{{ getUserName(user) }}</option>
							</select>
							<has-error :form="form" field="meta_data.approvers"></has-error>
						</div>
						<div class="form-group col-12">
							<label>Number of Approvers Required</label>
							<input
								v-model="form.number_of_approvers_required"
								type="number"
								min="1"
								class="form-control"
								:class="{ 'is-invalid': form.errors.has('form.meta.approvers') }"
								placeholder="Please enter number of approver need to approve"
								required
							/>
							<has-error :form="form" field="number_of_approvers_required"></has-error>
						</div>
						<div class="form-group col-12">
							<label>Requested By</label>
							<select v-model="form.requested_by" id="requested_by" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('requested_by') }" required>
								<option :value="null" disabled>Select company user</option>
								<option v-for="(user, index) in companyUsers" :value="user.user_id" :key="index">{{ getUserName(user) }}</option>
							</select>
							<has-error :form="form" field="requested_by"></has-error>
						</div>

						<div class="col-12">
							<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
								<button-component
									:busy="form.busy"
									:label="'Create Policy'"
									:label-loading="'Please wait...'"
									:button-class="'btn btn-default shadow-sm mg-b-5 mg-sm-b-0'"
								></button-component>
								<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" @click="resetForm">Cancel</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	mounted() {
		$('#company').select2({
			placeholder: 'Select company',
			width: '100%',
			ajax: {
				url: '/api/companies',
				dataType: 'json',
				width: '100%',
				headers: {
					Authorization: `Bearer ${localStorage.token}`
				},
				data: function({ term }) {
					return {
						filter: term
					};
				},
				processResults: function({ data }) {
					const results = _.map(data.companies, data => {
						return {
							id: data.external_client_id,
							text: `${data.name} (${data.external_client_id})`
						};
					});

					return {
						results
					};
				}
			}
		});

		$('#company').on('select2:select', ({ params: { data } }) => {
			this.loadUsers(data.id);
			this.form.external_client_id = data.id;
		});
		$('#company').on('select2:unselect', e => {
			this.form.external_client_id = null;
		});
	},
	data() {
		return {
			companyUsers: [],
			form: new Form({
				external_client_id: null,
				requested_by: null,
				policy_type: null,
				number_of_approvers_required: null,
				meta_data: {
					approvers: []
				}
			})
		};
	},
	computed: {
		...mapGetters({
			policyTypes: 'policyTypes'
		}),
		approvers() {
			return this.companyUsers.filter(user => user.designation === 'approver');
		}
	},
	methods: {
		resetForm() {
			this.form.clear();
			this.form.reset();
			$('#company')
				.val(null)
				.trigger('change');
		},
		getUserName(user) {
			return user.first_name + ' ' + user.last_name;
		},
		loadUsers(companyId) {
			axios
				.get(`/api/companies/${companyId}/users`)
				.then(({ data: { data } }) => {
					this.companyUsers = data.users;
				})
				.catch(({ response }) => console.log(response));
		},
		createPolicy() {
			this.form
				.post('/api/policies')
				.then(({ data: { data } }) => {
					console.log(data);
					this.$router.push({
						name: 'policies.show',
						params: { policy: data.policy.id }
					});
				})
				.catch(({ response }) => console.log(response));
		}
	}
};
</script>

<style></style>
